import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CustomerServiceService } from "../customer-service.service";
import { Router } from "@angular/router";
import { CommonServices } from "src/app/common.services";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { LrUpdateComponent } from '../lr-update/lr-update.component';
import * as _ from "lodash";

@Component({
  selector: "app-trips-details",
  templateUrl: "./trips-details.component.html",
  styleUrls: ["./trips-details.component.css"],
})
export class TripsDetailsComponent implements OnInit {
  token: any;
  trips: any;
  paid_amount: any;
  total_amount: any;
  balance_amount: any;
  modeldata: any;
  paymentArray: any;
  trip_history: any = [];
  filteredPaymentArray: any[] = [];
  corporatePaymnents: boolean = false;
  isGeneratingELR: boolean = false;
  tripNumber: any = -1;
  startPage: any = 1;
  tripType: any = "-1";
  downloadingLRIndex: number | null = null;

  constructor(
    private matdialogref: MatDialogRef<TripsDetailsComponent>,
    private router: Router,
    private services: CustomerServiceService,
    @Inject(MAT_DIALOG_DATA) data: any,
    private commonService: CommonServices,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {
    this.modeldata = data;
  }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("token");
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
    if (this.modeldata.payment_details.length < 2) {
      this.paymentArray =
        this.modeldata.payment_details[0]?.price_details?.payment_history;
      this.corporatePaymnents = false;
    } else {
      this.filterPayments();
      this.corporatePaymnents = true;
    }

    this.trip_history = this.getLatestEntries(
      this.modeldata?.trip_history
    ).filter(
      (history) =>
        history?.is_verified !== 0
    );
  }

  generateELR(modeldata: any) {
    this.isGeneratingELR = true;
    const tripId = modeldata?._id;
    this.services.generateELR(tripId, this.token).subscribe(
      (response: any) => {
        console.log('eLR generated:', response.body);
        this.refreshTripELR(modeldata._id);
      },
      (error: any) => {
        console.error('LR generation failed', error);
        this.isGeneratingELR = false;
      }
    );
  }

  onEdit(modeldata: any, index: number) {
    const dialogRef = this.dialog.open(LrUpdateComponent, {
      width: '100%',
      maxHeight: '80vh',
      disableClose: true,
      data: {
        items: modeldata,
        index
      }
    });
    dialogRef.afterClosed().subscribe((updated: boolean) => {
      if (updated) {
        this.refreshTripELR(modeldata._id);
      }
    });
  }

  DownloadLR(item: any, i: number) {
    if (this.downloadingLRIndex === i) {
      return; // prevent duplicate click
    }
    this.downloadingLRIndex = i;
    const token = localStorage.getItem("token");
    const trip_no = item?.trip_id;
    const elr_no = item.elr_details[i].elr_no;
    const trip_id = item?._id;
    const elr_id = item.elr_details[i]._id;
    this.services.downloadELR(token, trip_id, elr_id).subscribe(
      (res: any) => {
        const blob = res.body;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `eLR_${trip_no}_${elr_no}.pdf`;
        a.click();
        URL.revokeObjectURL(url);
        this.downloadingLRIndex = null; // stop loader
      },
      (err) => {
        console.error("ELR download error:", err);
        this.downloadingLRIndex = null; // stop loader on error
      }
    );
  }

  refreshTripELR(tripId: string) {
    this.services
      .GetTripList(this.token, this.startPage, this.tripType, this.tripNumber)
      .subscribe((res: any) => {
        const updatedTrip = res.body.data.find(
          (t: any) => t._id === tripId
        );

        if (updatedTrip) {
          this.modeldata.elr_details = updatedTrip.elr_details;
        }
        this.isGeneratingELR = false;
      });
  }

  filterPayments() {
    this.filteredPaymentArray = this.modeldata.payment_details
      .map((detail: any) => detail.price_details.payment_history)
      .flat()
      .filter(
        (
          payment: { payment_comment: string | string[] },
          index: any,
          self: any
        ) =>
          payment.payment_comment.includes("80%") ||
          payment.payment_comment.includes("20%")
      )
      .filter(
        (payment: { payment_comment: any }, index: any, self: any[]) =>
          index ===
          self.findIndex((p) => p.payment_comment === payment.payment_comment)
      );
  }

  private getLatestEntries(data: any[]): any[] {
    const latestEntries = new Map<string, any>();

    data.forEach((item) => {
      const existing = latestEntries.get(item.name);
      if (!existing || new Date(item.date) > new Date(existing.date)) {
        latestEntries.set(item.name, item);
      }
    });

    return Array.from(latestEntries.values());
  }

  close() {
    this.matdialogref.close();
  }
}
